import React, { Component } from 'react'

export default class Erfaringkomponent extends Component {
  render() {
    return (
      <div>
        <h1>erfaring</h1>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Erfaringkomponent.js